module.exports = __webpack_public_path__ + "img/Setup.552c712c.svg";